enum MAINTENANCE_TYPE {
  ALL = 'all',
  DEMANDS = 'demands',
  DEMANDS_DETAILS = 'demands_details',
  GED = 'ged',
  CREATE_USERS = 'create_users',
}

export enum MAINTENANCE_TAB {
  GENERIC_TEXT = 1,
  GENERIC_TEXT_WITH_FORM = 2,
  PERSONALIZED_TEXT = 3,
}

export default MAINTENANCE_TYPE
